import { useEffect } from "react";
import { BRAND } from "../config/brand";

const OG_LOCALE = { it: "it_IT", en: "en_US", es: "es_ES" };

const LOGO_IMAGE = { url: "/icons/icon-512.png", width: 512, height: 512, alt: "SYNrise logo" };

// Per-route meta via React 19 native <title>/<meta>/<link> hoisting.
// `image` (path relative to the site, with width/height/alt) switches the share card to a large image.
export const Seo = ({ title, description, path, lang = "it", noindex = false, alternates = [], jsonLd, image }) => {
  useEffect(() => {
    document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());
  }, []);

  const url = path != null ? `${BRAND.siteUrl}${path}` : null;
  const img = image || LOGO_IMAGE;
  const imageUrl = `${BRAND.siteUrl}${img.url}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {url && <link rel="canonical" href={url} />}
      {alternates.map((a) => (
        <link key={a.hreflang} rel="alternate" hrefLang={a.hreflang} href={`${BRAND.siteUrl}${a.path}`} />
      ))}
      {!noindex && (
        <>
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="SYNrise" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          {url && <meta property="og:url" content={url} />}
          <meta property="og:image" content={imageUrl} />
          <meta property="og:image:width" content={String(img.width)} />
          <meta property="og:image:height" content={String(img.height)} />
          <meta property="og:image:alt" content={img.alt} />
          <meta property="og:locale" content={OG_LOCALE[lang] || "it_IT"} />
          <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={imageUrl} />
          {image && <meta name="twitter:image:alt" content={img.alt} />}
        </>
      )}
      {jsonLd && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />}
    </>
  );
};
